import React from 'react'
import _ from 'lodash'


export default class TagSorter extends React.PureComponent {
    onTagSelect = (e) => {
        const { isMobile, onTagSet } = this.props,
            tag = !isMobile ? [ e.currentTarget.dataset.tag ] : [ e.currentTarget.value ];

        onTagSet(tag);
    }

    TagItem = (item, idx) => {
        const { isMobile, tagSelected } = this.props;

        return (!isMobile
            ?
            <div
                className={`tag-btn ${(tagSelected.indexOf(item) > -1) ? 'active' : ''}`}
                data-tag={item}
                onClick={this.onTagSelect}
                key={idx}
            >
                <span>{item}</span>
            </div>
            :
            <option key={idx} value={item}>{item}</option>);
    }

    componentDidUpdate(prevProps, prevState) {
        const { tags, onTagSet } = this.props;

        if (!_.isEqual(prevProps.tags, tags)) {
            onTagSet([ 'all' ]);
        }
    }

    render() {
        const { isMobile, tags, tagSelected } = this.props;

        return (
            <div className="product-tag text-center">
                {isMobile
                    ?
                    <form className="selection-box-container ua-form" name="product-tag-form" action="">
                        <fieldset>
                            <section className="padding-left-15 inputs">
                                <label className="d-inline-block">篩選：</label>

                                <div className="select ua-input">
                                    <div className="ua-triangle"/>

                                    <select
                                        name="filter"
                                        ref={(ref) => (this.filter = ref)}
                                        onChange={this.onTagSelect}
                                    >
                                        <option value="all">顯示全部</option>

                                        {tags.map(this.TagItem)}
                                    </select>
                                </div>
                            </section>
                        </fieldset>
                    </form>
                    :
                    <div className="tag-sorter">
                        <div
                            className={`tag-btn ${(tagSelected.indexOf('all') > -1) ? 'active' : ''}`}
                            data-tag="all"
                            onClick={this.onTagSelect}
                        >
                            顯示全部
                        </div>

                        {tags.map(this.TagItem)}
                    </div>}
            </div>
        );
    }
}
